'use client';
import { ReactNode } from 'react';

interface HeaderMenuProps {
  children: ReactNode;
  gap?: string;
  justify_content?: string;
  align_items?: string;
  className?: string;
}

const HeaderMenu = ({
  children,
  gap = "22px",
  justify_content = "center",
  align_items = "center",
  className = ""
}: HeaderMenuProps) => {
  const justifyClass = justify_content === "center" ? "justify-center" : 
                      justify_content === "start" ? "justify-start" : 
                      justify_content === "end" ? "justify-end" : 
                      justify_content === "spaceBetween" ? "justify-between" : "justify-center"
  
  const alignClass = align_items === "center" ? "items-center" : 
                     align_items === "start" ? "items-start" : 
                     align_items === "end" ? "items-end" : "items-center"

  return (
    <nav data-component-id="src/components/ui/HeaderMenu.tsx:29:4" data-component-path="src/components/ui/HeaderMenu.tsx" data-component-line="29" data-component-end-line="35" data-component-file="HeaderMenu.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D" 
      className={`flex flex-row ${justifyClass} ${alignClass} w-auto ${className}`}
      style={{ gap }}
      role="navigation"
    >
      {children}
    </nav>
  )
}

export default HeaderMenu